import { Link } from "@/lib/router-compat";
import {
  Map,
  Wine,
  ShoppingCart,
  MessageSquare,
  BookOpen,
  Shield,
  FileText,
  Info,
  Download,
  HelpCircle,
} from "lucide-react";

const sections = [
  {
    title: "Main Pages",
    links: [
      {
        to: "/",
        label: "Home",
        icon: Wine,
        description: "Discover the Gatlinburg Wine Trail experience",
      },
      {
        to: "/checkout",
        label: "Get Your Trail Pass",
        icon: ShoppingCart,
        description: "Purchase your VIP Trail Pass for $10",
      },
      {
        to: "/how-it-works",
        label: "How the Trail Works",
        icon: Info,
        description: "Buying, activating and finishing the trail, step by step",
      },
      {
        to: "/about",
        label: "About Us",
        icon: Info,
        description: "Learn about the Gatlinburg Wine Trail",
      },
      {
        to: "/contact",
        label: "Contact",
        icon: MessageSquare,
        description: "Get in touch with our team",
      },
      {
        to: "/install",
        label: "Install App",
        icon: Download,
        description: "Add the Wine Trail app to your phone",
      },
    ],
  },
  {
    title: "Trail Experience",
    links: [
      {
        to: "/my-passes",
        label: "My Passes",
        icon: Map,
        description: "View your trail pass and track progress",
      },
    ],
  },
  {
    title: "Blog & Resources",
    links: [
      {
        to: "/blog",
        label: "Blog",
        icon: BookOpen,
        description: "Tips, stories, and guides for the Wine Trail",
      },
    ],
  },
  {
    title: "Legal & Policies",
    links: [
      {
        to: "/terms",
        label: "Terms of Service",
        icon: FileText,
        description: "Our terms of service",
      },
      {
        to: "/terms-and-conditions",
        label: "Terms & Conditions",
        icon: FileText,
        description: "Trail pass terms and conditions",
      },
      {
        to: "/privacy",
        label: "Privacy Policy",
        icon: Shield,
        description: "How we handle your data",
      },
    ],
  },
];

const Sitemap = () => {
  return (
    <>
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-2">
          Sitemap
        </h1>
        <p className="text-muted-foreground font-body mb-12">
          A complete index of every page on the Gatlinburg Wine Trail website.
        </p>

        <div className="grid gap-10">
          {sections.map((section) => (
            <section key={section.title}>
              <h2 className="font-display text-lg font-semibold text-gold uppercase tracking-wider mb-4 border-b border-border pb-2">
                {section.title}
              </h2>
              <ul className="space-y-3">
                {section.links.map((link) => {
                  const Icon = link.icon;
                  return (
                    <li key={link.to}>
                      <Link
                        to={link.to}
                        className="flex items-start gap-3 group p-3 rounded-lg hover:bg-card/60 transition-colors"
                      >
                        <Icon className="h-5 w-5 text-gold mt-0.5 shrink-0" />
                        <div>
                          {" "}
                          <span className="font-body font-medium text-foreground group-hover:text-gold transition-colors">
                            {link.label}
                          </span>
                          <p className="text-sm text-muted-foreground">
                            {link.description}
                          </p>
                        </div>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sitemap;
